import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getRecurringAppointments } from 'api/Appointment';

import { DEFAULT_QUERY_OPTIONS } from 'lib/constants/queries/defaultQueryOptions';

export const useRecurringAppointments = ({ params = {}, options = {}, dependencies = [] } = {}) => {
  const navigate = useNavigate();

  return useQuery(
    ['recurring-appointments', ...dependencies],
    () => getRecurringAppointments(navigate, params),
    {
      ...DEFAULT_QUERY_OPTIONS,
      ...options
    }
  );
};
